import { Route } from "@angular/router";

export const DIMENSIONS_ROUTES: Route[] = [
  {
    path: "dimensions",
    children: [
      {
        path: "",
        loadComponent: () => import("../../shared/components/").then((e) => e.SubmenuComponent),
        data: {
          breadcrumb: "breadcrumbs.dimensions_module.list",
          title: "breadcrumbs.dimensions_module.list",
        },
      },
    ],
  },
];
